var exports = {
  "vU": "App.module__appContainer___aVp0Vj",
  "lq": "App.module__overlayScope___aVp0Vj",
  "u$": "App.module__skipLink___aVp0Vj",
  "pq": "App.module__quickSwitcherPortal___aVp0Vj",
};

module.exports = exports;
